import { 
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
} from "@material-ui/core"

import React, { Component } from "react"

/**
 * box - коробка.
 * 
 * onEditBoxClick(Box) - запрос на редактирование коробки.
 * onCancelClick() - запрос отмены.
 */

class EditBoxDialog extends (Component) {

    constructor(props) {
        
        super(props)
        
        this.state = {
            code: "",
            dialog: undefined,
        }

    }

    componentDidMount() {
        if (this.props.box) {
            this.setState({
                code: this.props.box.code,
            })
        }
    }

    isReady() {
        if (this.state.code === this.props.box.code) {
            return false
        }
        if (this.state.code === "") {
            return false
        }
        return true
    }

    render() {

        if (this.state.dialog) {
            return this.state.dialog
        }

        return <Dialog
            open = {true}
            fullWidth = {true}        
        >

            <DialogTitle>
				Редактировать коробку
			</DialogTitle>

            <DialogContent style = {{display: "flex", flexDirection: "column"}}>
                
                <TextField
					value = {this.state.code}
					label = "Код коробки"
					margin = "normal"
					onChange = {e => {
						e.preventDefault()
						this.setState({code: e.target.value})
					}}                    
                />

            </DialogContent>

            <DialogActions>

                <Button
                    disabled = {!this.isReady()}
                    onClick = {e => {
                        e.stopPropagation()
                        if (typeof this.props.onEditBoxClick === "function") {
                            this.props.onEditBoxClick({
                                id: this.props.box.id,
                                code: this.state.code,
                            })
                        }
                    }}
                >Сохранить</Button>

                <Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onCancelClick === "function") {
							this.props.onCancelClick()
						}
					}}
				>Отмена</Button>

            </DialogActions>

        </Dialog>

    }

}

export default EditBoxDialog